<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Solicitações'"
      :tableHeader="headers"
      :tableRows="listaDeSolicitacoes"
      :isEdit="true"
      :isDel="true"
      :isFinish="false"
      :isArquivo="true"
      v-on:datatable-updaterow="editarSolicitacao"
      v-on:datatable-deleterow="deletarSolicitacao"
      v-on:datatable-arquivo="gerarArquivo"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="atualizarSolicitacao"
    >
      <v-form v-model="estaValido">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>

          <v-col cols="12">
            <v-subheader>Dados do Fiscal</v-subheader>
            <v-divider />
          </v-col>

          <v-col cols="2">
            <v-img
              :src="modalCustomSize.solicitacao.fotoUsuario"
              :lazy-src="modalCustomSize.solicitacao.fotoUsuario"
              aspect-ratio="1"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="blue lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>

          <v-col cols="10">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.nomeUsuario"
                  name="nomeUsuario"
                  label="Nome do Fiscal"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.cpfUsuario"
                  name="cpfUsuario"
                  label="CPF do Fiscal"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.emailUsuario"
                  name="emailUsuario"
                  label="Email do Fiscal"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="12">
            <v-subheader>Dados da Empresa</v-subheader>
            <v-divider />
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.nomeFantasiaEmpresa"
                  name="nomeFantasiaEmpresa"
                  label="Nome Fantasia"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.razaoSocialEmpresa"
                  name="razaoSocialEmpresa"
                  label="Razão Social"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-text-field
                  readonly
                  v-model="modalCustomSize.solicitacao.cevsEmpresa"
                  name="cevsEmpresa"
                  label="CEVS"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-subheader>Não Conformidades</v-subheader>
            <v-divider />
          </v-col>

          <v-col cols="12">
            <v-row v-for="(questao, i) in modalCustomSize.solicitacao.questoesSolicitadas" :key="i">
              <v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="questao.questao.nomeQuestao"
                    name="nomeQuestao"
                    label="Questão"
                    autocomplete="off"
                    rows="4"
                    row-height="30"
                    readonly
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="questao.questao.descricaoQuestao"
                    name="descricaoQuestao"
                    autocomplete="off"
                    label="Lei"
                    readonly
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-if="questao.respostaQuestao.observacao"
                    v-model="questao.respostaQuestao.observacao"
                    name="descricaoObservacao"
                    autocomplete="off"
                    label="Observação"
                    rows="3"
                    row-height="20"
                    readonly
                  />
                </v-col>

                <v-col v-if="questao.fotos && questao.fotos.length > 0" cols="12">
                  <v-row>
                    <v-col
                      v-for="(foto, l) in questao.fotos"
                      :key="l"
                      class="d-flex child-flex"
                      cols="3"
                    >
                      <img
                        v-img
                        :src="'data:image/jpeg;base64,' + foto.caminhoFoto"
                        :lazy-src="'data:image/jpeg;base64,' + foto.caminhoFoto"
                        width="100"
                        height="150"
                        style="object-fit: cover;"
                        class="white lighten-2"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>

              <v-col v-if="questao.listaAlternativa.length > 0" cols="5">
                <v-row
                  cols="12"
                  align="center"
                  v-for="(alternativa, k) in questao.listaAlternativa"
                  :key="k"
                >
                  <v-col v-if="alternativa.alternativa.tipoAlternativa == 0" cols="12">
                    <v-radio-group v-model="questao.respostaQuestao.descricaoResposta">
                      <v-radio 
                        :value="alternativa.alternativa.nomeAlternativa"
                        :label="alternativa.alternativa.nomeAlternativa"
                        :name="questao.respostaQuestao.descricaoResposta"
                        readonly
                      />
                    </v-radio-group>
                  </v-col>

                  <v-col v-if="alternativa.alternativa.tipoAlternativa == 1" cols="12">
                    <v-checkbox
                      v-model="alternativa.respostaAlternativa.descricaoResposta"
                      :label="alternativa.alternativa.nomeAlternativa"
                      :true-value="alternativa.respostaAlternativa.descricaoResposta"
                      :name="questao.questao.nomeQuestao"
                      readonly
                    />
                  </v-col>

                  <v-col v-if="alternativa.alternativa.tipoAlternativa == 2" cols="12">
                    <v-text-field
                      v-model="alternativa.respostaAlternativa.descricaoResposta"
                      autocomplete="off"
                      :label="alternativa.alternativa.nomeAlternativa"
                      :name="questao.questao.nomeQuestao"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-autocomplete
              label="Status Solicitação"
              autocomplete="off"
              :items="statusSolicitacao"
              v-model="statusSelecionado"
              :rules="[rules.requerido]"
            />
          </v-col>

          <v-expand-transition>
            <v-col v-if="mostrarDescricaoStatus || modalCustomSize.solicitacao.descricaoSolicitacao" cols="12">
              <v-textarea
                v-model="modalCustomSize.solicitacao.descricaoSolicitacao"
                name="descricaoSolicitacao"
                label="Descrição do Status"
                autocomplete="off"
                rows="3"
                row-height="20"
              />
            </v-col>
          </v-expand-transition>
        </v-row>
      </v-form>
    </ModalCustomSize>
    
    <RelatorioAIF
      :isTheModalOpen="relatorioAif.estaAberto"
      :solicitacaoSelecionada="relatorioAif.solicitacaoSelecionada"
      v-on:relatorio-aif-close="fecharRelatorio"
    ></RelatorioAIF>

    <RelatorioAIP
      :isTheModalOpen="relatorioAip.estaAberto"
      :solicitacaoSelecionada="relatorioAip.solicitacaoSelecionada"
      v-on:relatorio-aif-close="fecharRelatorio"
    ></RelatorioAIP>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import ModalCustomSize from "../components/ModalCustomSize";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import RelatorioAIF from "../components/Relatorios/AIF.vue";
import RelatorioAIP from "../components/Relatorios/AIP.vue";

export default {
  components: {
    DataTable,
    SkeletonTable,
    ModalCustomSize,
    Alertas,
    AlertasModal,
    RelatorioAIF,
    RelatorioAIP
  },

  sockets: {
    reciveInsert: function (data) {
      if(data.tarefa.tipoTarefa == 0 || data.tarefa.tipoTarefa == 2  && data.descricaoTela == "sincronizarTarefa") {
        if(data.solicitacao.solicitado) {
          this.alertaSocket.texto = 'Nova Solicitação foi criada.'
          this.alertaSocket.tipo = 'info'
          this.inicializar();
        }
      }
    },
  },

  data: () => ({
    rules: {
      requerido: (value) => value != null || "Requer o campo!",
    },

    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    showSkeletonTable: true,
    estaValido: false,
    mostrarDescricaoStatus: false,

    relatorioAif: {
      estaAberto: false,
      solicitacaoSelecionada: null
    },

    relatorioAip: {
      estaAberto: false,
      solicitacaoSelecionada: null
    },

    modalCustomSize: {
      size: "1600",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isView: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: false,
      isButtonsDisabled: false,
      solicitacao: {
        numeroSolicitacao: null,
        numeroTarefaDerivada: null,
        numeroTarefaGerada: null,

        numeroUsuario: null,
        fotoUsuario: null,
        nomeUsuario: null,
        cpfUsuario: null,
        emailUsuario: null,

        numeroEmpresa: null,
        nomeFantasiaEmpresa: null,
        razaoSocialEmpresa: null,
        cevsEmpresa: null,
        questoesSolicitadas: [],

        statusSolicitacao: null,
        descricaoSolicitacao: null
      },
    },

    headers: [
      {
        text: "ID",
        value: "solicitacao.numeroSolicitacao",
      },
      {
        text: "Empresa",
        value: "tarefaGerada.empresa.nomeFantasia",
      },
      {
        text: "Endereço",
        value: "tarefaGerada.endereco.endereco",
      },
      {
        text: "Fiscal",
        value: "tarefaGerada.usuario.nomeUsuario",
      },
      {
        text: "Roteiro Tarefa Derivada",
        value: "tarefaDerivada.roteiro.nomeRoteiro",
      },
      {
        text: "Prazo",
        value: "tarefaGerada.tarefa.dataTarefa",
      },
      {
        text: "Tipo",
        value: "solicitacao.indicadorTipo",
      },
      {
        text: "Status",
        value: "solicitacao.indicadorStatus",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    listaDeSolicitacoes: [],

    statusSelecionado: null,
    statusSolicitacao: [
      {
        text: 'Aguardando Aprovação',
        value: 0
      },
      {
        text: 'Aprovar',
        value: 1
      },
      {
        text: 'Recusar',
        value: 2
      }
    ]

  }),

  created() {
    this.inicializar();
  },

  watch: {
    estaValido() {
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
    },

    statusSelecionado() {
      this.modalCustomSize.solicitacao.statusSolicitacao = this.statusSelecionado
      if(this.statusSelecionado == 2) {
        this.mostrarDescricaoStatus = true
      } else {
        this.mostrarDescricaoStatus = false
        this.modalCustomSize.solicitacao.descricaoSolicitacao =  null
      }
    }
  },

  methods: {
    async inicializar() {
      this.showSkeletonTable = true
      try {
        const response = await axios.get('solicitacao', this.config)
        this.listaDeSolicitacoes = response.data
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.showSkeletonTable = false
      }
    },

    async atualizarSolicitacao() {
      try {
        this.alertaModal.tipo = null;
        await axios.put('solicitacao', this.modalCustomSize.solicitacao, this.config)
        this.$socket.emit("insertLog");
        this.alerta.texto = "Status da Solicitação foi atualizada"
        this.alerta.tipo = 'sucesso'
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = 'erro';
      } finally {
        this.modalCustomSize.isOpen = false;
        this.inicializar()
      }
    },

    async deletarSolicitacao(solicitacaoSelecionado) {
      try {
        if(confirm("Você realmente deseja excluir esta Solicitação?")){
          this.erro = false;
          await axios.delete("solicitacao", {
            data: solicitacaoSelecionado,
            headers: this.config.headers,
          });
          this.$socket.emit("insertLog");
          this.alerta.texto = "Solicitação removida"
          this.alerta.tipo = 'sucesso';
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.inicializar()
      }
    },

    async gerarArquivo(solicitacaoSelecionado) {
      if(solicitacaoSelecionado.solicitacao.indicadorTipo == 0) {
        this.relatorioAif.estaAberto = false
        this.relatorioAip.solicitacaoSelecionada = solicitacaoSelecionado
        this.relatorioAip.estaAberto = true
      } else if(solicitacaoSelecionado.solicitacao.indicadorTipo == 1) {
        this.relatorioAip.estaAberto = false
        this.relatorioAif.solicitacaoSelecionada = solicitacaoSelecionado
        this.relatorioAif.estaAberto = true
      }
    },

    async editarSolicitacao(solicitacaoSelecionado) {
      try {
        this.alertaModal.texto = null
        this.alertaModal.tipo = null;

        let tarefaCompleta = await axios.put("solicitacaoCompleta", solicitacaoSelecionado.solicitacao, this.config);
        this.modalCustomSize.solicitacao.questoesSolicitadas = tarefaCompleta.data
      
        this.modalCustomSize.solicitacao.numeroSolicitacao = solicitacaoSelecionado.solicitacao.numeroSolicitacao
        this.modalCustomSize.solicitacao.numeroTarefaDerivada = solicitacaoSelecionado.solicitacao.numeroTarefaDerivada
        this.modalCustomSize.solicitacao.numeroTarefaGerada = solicitacaoSelecionado.solicitacao.numeroTarefaGerada
        this.statusSelecionado = solicitacaoSelecionado.solicitacao.indicadorStatus
        this.modalCustomSize.solicitacao.statusSolicitacao = solicitacaoSelecionado.solicitacao.indicadorStatus
        this.modalCustomSize.solicitacao.descricaoSolicitacao = solicitacaoSelecionado.solicitacao.descricaoStatus

        this.modalCustomSize.solicitacao.numeroUsuario = solicitacaoSelecionado.tarefaDerivada.usuario.numeroUsuario
        this.modalCustomSize.solicitacao.fotoUsuario = solicitacaoSelecionado.tarefaDerivada.usuario.foto
        this.modalCustomSize.solicitacao.nomeUsuario = solicitacaoSelecionado.tarefaDerivada.usuario.nomeUsuario
        this.modalCustomSize.solicitacao.cpfUsuario = solicitacaoSelecionado.tarefaDerivada.usuario.cpf
        this.modalCustomSize.solicitacao.emailUsuario = solicitacaoSelecionado.tarefaDerivada.usuario.email

        this.modalCustomSize.solicitacao.numeroEmpresa = solicitacaoSelecionado.tarefaDerivada.empresa.numeroEmpresa
        this.modalCustomSize.solicitacao.nomeFantasiaEmpresa = solicitacaoSelecionado.tarefaDerivada.empresa.nomeFantasia
        this.modalCustomSize.solicitacao.razaoSocialEmpresa = solicitacaoSelecionado.tarefaDerivada.empresa.razaoSocial
        this.modalCustomSize.solicitacao.cevsEmpresa = solicitacaoSelecionado.tarefaDerivada.endereco.cevs
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = 'erro';
      } finally {
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isView = false;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.isButtonsDisabled = !this.estaValido
        this.modalCustomSize.buttonText = "Atualizar";
        this.modalCustomSize.formTitle = "Atualizar Solicitação";
      }
    },

    fecharRelatorio() {
      this.relatorioAip.solicitacaoSelecionada = null
      this.relatorioAip.estaAberto = false

      this.relatorioAif.solicitacaoSelecionada = null
      this.relatorioAif.estaAberto = false
    }
    
  },
};
</script>
